import React, { FC, useEffect } from 'react'
import { Box, useMediaQuery, useTheme } from '@material-ui/core'
import { useAppDispatch } from 'Context/AppContext/AppContext'
import useConfigureActivePlans from 'Hooks/useConfigureActivePlans/useConfigureActivePlans'
import { UPDATE_DISPLAY_PROGRESS } from 'TypeDefs/AppContext'

const PageWrapper: FC<{ className?: string }> = ({ children, className }) => {
  const theme = useTheme()
  const isScreenLarge = useMediaQuery(theme.breakpoints.up('md'))

  const padding = isScreenLarge ? 5 : 2
  const dispatch = useAppDispatch()
  const { isFunderUser } = useConfigureActivePlans()
  const paddingTop = isFunderUser ? 12 : 0

  // default to not display page specific app bar components
  useEffect(() => {
    dispatch({
      type: UPDATE_DISPLAY_PROGRESS,
      displayLinearProgress: false,
    })
  }, [dispatch])

  return (
    <Box pr={padding} pl={padding} pt={paddingTop} className={className}>
      {children}
    </Box>
  )
}

export default PageWrapper
